export default function isInPreview(){
	return window.location.hostname === 'preview-dot-shop-template-dot-rcm55-bagshop.appspot.com';
}
